// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import AdminDrawerController from "./admin_drawer_controller"
application.register("admin-drawer", AdminDrawerController)

import ApprovedMemberPickerController from "./approved_member_picker_controller"
application.register("approved-member-picker", ApprovedMemberPickerController)

import PublicPageEditorController from "./public_page_editor_controller"
application.register("public-page-editor", PublicPageEditorController)

import JoinNetworkController from "./join_network_controller"
application.register("join-network", JoinNetworkController)
